export const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'];

export const MONTHS_CAPITALIZED = MONTHS.map(m => m.charAt(0).toUpperCase() + m.slice(1));

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** Canonical site hosts — see specs/environments.md */
export { PROD_HOST, PRE_PROD_HOST } from '../../lib/preprod';
